import { addFilter } from '@wordpress/hooks'
import { useSelect, dispatch } from '@wordpress/data'
import { PanelRow, TextControl, ToggleControl } from '@wordpress/components'
import { __ } from '@wordpress/i18n'

/**
 * Adding Paystack Content
 */
addFilter( 'wp_travel_payment_gateway_fields_paystack', 'wp-travel', (content) => {
    return [ ...content, <PayStackContent /> ]
});

const PayStackContent = () => {

    /**
     * Get Store Settings.
     */
    const { updateSettings } = dispatch('WPTravel/Admin');

    const allData = useSelect( (select) => {
        return select('WPTravel/Admin').getAllStore()
    }, [] );

    const {
        payment_option_paystack,
        paystack_public_key,
        paystack_test_public_key,
        wt_test_mode
    } = allData

    console.log(allData)

    return (
        <>
            {
                wt_test_mode === 'yes' ?
                <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Test Mode Active', 'wp-travel-paystack-checkout' ) }</p></strong>
                : <strong><p className="howTo" style={{color: '#ffffff', textAlign: 'center', backgroundColor: 'darkseagreen'}} >{ __( 'Live Mode Active', 'wp-travel-paystack-checkout' ) }</p></strong>
            }
            <PanelRow>
                <label>{ __( 'Enable Paystack', 'wp-travel-paystack-checkout' ) }</label>
                <div className="wp-travel-field-value">
                    <ToggleControl
                        checked={ payment_option_paystack == 'yes' }
                        onChange={ () => {
                            updateSettings({
                                ...allData,
                                payment_option_paystack: 'yes' == payment_option_paystack ? 'no': 'yes'
                            })
                        } }
                    />
                    <p className="description">{__( 'Check to enable Paysatck Checkout', 'wp-travel-paystack-checkout' )}</p>
                </div>
            </PanelRow>

            {
                payment_option_paystack === 'yes' &&
                <>
                    <PanelRow>
                        <label>{ __( 'Test Public Key', 'wp-travel-paystack-checkout' ) }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof paystack_test_public_key ? paystack_test_public_key : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                paystack_test_public_key: value
                                            })
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>

                    <PanelRow>
                        <label>{ __( 'Live Public Key', 'wp-travel-paystack-checkout' ) }</label>
                            <div className="wp-travel-field-value">
                                <TextControl
                                    value={ 'undefined' !== typeof paystack_public_key ? paystack_public_key : '' }
                                    onChange={
                                        (value) => {
                                            updateSettings({
                                                ...allData,
                                                paystack_public_key: value
                                            })
                                        }
                                    }
                                />
                            </div>
                    </PanelRow>
                </>
            }
        </>
    )
}